import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import Template from "./booking-color-selection.html";
import Controller from "./booking-color-selection.controller";
import BookingColorSelectionModal from "./booking-color-selection.modal";

let BookingColorSelectionModule = Angular.module('booking-color-selection', []);

BookingColorSelectionModule.component('bookingColorSelection', {
    template: Template,
    controller: Controller,
    bindings: {
        color: '<',
        colorCols: "<",
        colorRowClass: '@',
        colorColClass: '@',
        onColorSelected: '&'
    },
});

new Loader(BookingColorSelectionModule)
    .load(BookingColorSelectionModal);

export default BookingColorSelectionModule;



// WEBPACK FOOTER //
// ./src/modules/main/components/booking-color-selection/booking-color-selection.js